export enum AppType {
	municipality = 'Municipality',
	supplier = 'Supplier',
}
